<template>
    <exchange-info 
        ref="list"
        header-text="換金情報"
        >
        <div v-if="getListObj">
            <div v-if="getListObj.data.length > 0">
                <div class="card mb-2" v-for="item in getListObj.data" :key="item.id" @click="toExchangeMonth(item.exchange_num)">
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item text-muted py-1">
                            <div class="d-flex align-items-center">
                                <span>
                                    <small> 換金番号&nbsp;{{item.exchange_num}} </small>
                                </span>
                            </div>
                        </li>
                        <li class="list-group-item pb-1 let-space-1">
                            <div class="d-flex align-items-center">
                                <span><i class="fas fa-donate text-warning-cust icon-size"></i></span>
                                <span class="badge badge-pill badge-warning py-1 mx-3 text-truncate">依頼済</span>
                                <span class="badge badge-pill badge-warning py-1 text-truncate">{{item.wait_cnt}}件</span>
                                <span class="flex-fill text-right">
                                    <b>{{toLocaleString(item.wait_points)}}</b><small>Pt</small>
                                </span>
                            </div>
                            <div class="d-flex align-items-center">
                                <span><i class="fas fa-donate text-success icon-size"></i></span>
                                <span class="badge badge-pill badge-success py-1 mx-3 text-truncate">処理中</span>
                                <span class="badge badge-pill badge-success py-1 text-truncate">{{item.proc_cnt}}件</span>
                                <span class="flex-fill text-right">
                                    <b>{{toLocaleString(item.proc_points)}}</b><small>Pt</small>
                                </span>
                            </div>
                            <div class="d-flex align-items-center">
                                <span><i class="fas fa-donate text-secondary icon-size"></i></span>
                                <span class="badge badge-pill badge-secondary py-1 mx-3 text-truncate">振込済</span>
                                <span class="badge badge-pill badge-secondary py-1 text-truncate">{{item.done_cnt}}件</span>
                                <span class="flex-fill text-right">
                                    <b>{{toLocaleString(item.done_points)}}</b><small>Pt</small>
                                </span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </exchange-info>
</template>

<script>
    import ExchangeInfo from 'pages/commons/List/List'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            ExchangeInfo
        },
        mounted () {
            this.$refs.list.loadListObj({url:'invite.point.exchange'})
            this.$refs.list.resetRefresh('exchangeInfo')
        },
        activated () {
            this.$refs.list.isGetList('exchangeInfo', {url:'invite.point.exchange'})
            this.$refs.list.resetRefresh('exchangeInfo')
        },
        computed: {
            ...mapGetters(['getListObj'])
        },
        methods: {
            toLocaleString (num) {
                return Number(num).toLocaleString()
            },
            toExchangeMonth (month) {
                this.$store.dispatch('setRefreshArr', 'exchangeMonth')
                this.$router.push({name:'ExchangeMonth', params:{month: month}})
            }
        }
    }
</script>
